<template>
  <el-card>
    <el-row class="room_tab__title">房间列表tab配置</el-row>
    <!-- 搜索 -->
    <el-row class="room_tab__search">
      <span>类型：</span>
      <el-select
        v-model="searchInfo.tabType"
        clearable
        filterable
        placeholder="请选择"
      >
        <el-option
          v-for="(item, index) in constant"
          :key="index"
          :label="item.name"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-button style="margin-left: 10px" type="success" @click="getAllList"
        >搜索</el-button
      >
      <el-button
        style="margin-left: 10px"
        type="success"
        @click="
          () => {
            type = 0
            isDialog = true
          }
        "
        >添加</el-button
      >
    </el-row>
    <!-- 表格 -->
    <el-row>
      <el-table border :data="table">
        <el-table-column prop="id" label="id" align="center"> </el-table-column>
        <el-table-column label="类型" align="center">
          <template slot-scope="scope">
            {{ constant.find((item) => item.value === scope.row.tabType).name }}
          </template>
        </el-table-column>
        <el-table-column prop="tabName" label="标签名" align="center">
        </el-table-column>
        <el-table-column prop="tabCode" label="标签码" align="center">
        </el-table-column>
        <el-table-column prop="tabOrder" label="排序" sortable align="center">
        </el-table-column>
        <el-table-column label="状态" align="center">
          <template slot-scope="scope">
            {{ scope.row.valid === 0 ? '无效' : '有效' }}
          </template>
        </el-table-column>
        <el-table-column prop="operator" label="操作人" align="center">
        </el-table-column>
        <el-table-column prop="createDate" label="创建时间" align="center">
        </el-table-column>
        <el-table-column prop="fixDate" label="修改时间" align="center">
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button type="primary" @click="change(scope.row)"
              >修改</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <!-- 弹窗 -->
    <el-dialog
      :show-close="false"
      :close-on-click-modal="false"
      :visible.sync="isDialog"
      :close-on-press-escape="false"
      title="房间配置"
      class="config"
    >
      <el-row>
        <span>类型：</span>
        <el-select
          v-model="form.tabType"
          clearable
          filterable
          placeholder="请选择"
        >
          <el-option
            v-for="(item, index) in constant"
            :key="index"
            :label="item.name"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-row>
      <el-row>
        <span>标签名：</span>
        <el-input v-model="form.tabName" style="width: 250px"></el-input>
      </el-row>
      <el-row v-if="form.tabType">
        <span>标签码：</span>
        <el-select
          v-if="form.tabType === 1"
          v-model="form.tabCode"
          clearable
          filterable
          placeholder="请选择"
        >
          <el-option
            v-for="(item, index) in countryList"
            :key="index"
            :label="item.country"
            :value="item.countryCode"
          >
          </el-option>
        </el-select>
        <el-select
          v-else
          v-model="form.tabCode"
          clearable
          filterable
          placeholder="请选择"
        >
          <el-option
            v-for="(item, index) in langList"
            :key="index"
            :label="item.language"
            :value="item.langCode"
          >
          </el-option>
        </el-select>
      </el-row>
      <el-row>
        <span>排序：</span>
        <el-input v-model="form.tabOrder" style="width: 250px"></el-input>
      </el-row>
      <el-row v-if="type === 1">
        <span>有效值：</span>
        <el-switch
          v-model="form.valid"
          active-color="#13ce66"
          :active-value="1"
          :inactive-value="0"
        >
        </el-switch>
      </el-row>
      <el-row>
        <el-button @click="reset">取消</el-button>
        <el-button type="primary" @click="submit">确认</el-button>
      </el-row>
    </el-dialog>
  </el-card>
</template>

<script>
import { type } from 'vue-json-editor/assets/jsoneditor'

export default {
  data() {
    return {
      table: [],
      constant: [],
      countryList: [],
      langList: [],
      type: 0,
      table: [],
      dialogVisible: true,
      isDialog: false,
      searchInfo: {
        tabType: null,
      },
      form: {
        tabType: null,
        tabName: null,
        tabCode: null,
        tabOrder: null,
        valid: 0,
      },
    }
  },
  mounted() {
    this.getAllInfo()
  },
  methods: {
    getAllInfo() {
      this.getConstant()
      this.getAllList()
      this.getCountryCode()
      this.getLang()
    },
    // 获取常量
    async getConstant() {
      const { data: res } = await this.$axios({
        method: 'GET',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
        },
        url: this.$store.getters.path.room_tab_constant,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
        },
      })
      if (res.code !== 0) {
        return this.$message.error(res.msg)
      } else {
        this.constant = res.data
      }
    },
    // 获取数据
    async getAllList() {
      const { data: res } = await this.$axios({
        method: 'GET',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
        },
        url: this.$store.getters.path.room_tab_list,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          tabType: this.searchInfo.tabType,
        },
      })
      if (res.code !== 0) {
        return this.$message.error(res.msg)
      } else {
        this.table = res.data
      }
    },
    // 添加
    async add() {
      const data = {
        tabType: this.form.tabType,
        tabName: this.form.tabName,
        tabCode: this.form.tabCode,
        tabOrder: +this.form.tabOrder,
      }
      const { data: res } = await this.$axios({
        method: 'POST',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
        },
        url: this.$store.getters.path.room_tab_add,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
        },
        data,
      })
      if (res.code !== 0) {
        return this.$message.error(res.msg)
      } else {
        this.$message.success('修改成功')
        this.getAllList()
        this.reset()
      }
    },
    // 修改
    async update() {
      const data = {
        id: this.form.id,
        tabType: this.form.tabType,
        tabName: this.form.tabName,
        tabCode: this.form.tabCode,
        tabOrder: +this.form.tabOrder,
        valid: this.form.valid,
      }
      const { data: res } = await this.$axios({
        method: 'POST',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
        },
        url: this.$store.getters.path.room_tab_change,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
        },
        data,
      })
      if (res.code !== 0) {
        return this.$message.error(res.msg)
      } else {
        this.$message.success('修改成功')
        this.getAllList()
        this.reset()
      }
    },
    // 获取国家选项
    async getCountryCode() {
      const { data: res } = await this.$axios({
        method: 'POST',
        url:
          this.$store.getters.path.normal_country +
          '?username=' +
          this.$store.getters.username +
          '&token=' +
          this.$store.getters.token,
      })

      if (res.code != 0) {
        return this.$message.error(res.msg)
      } else {
        this.countryList = res.data.countryList
      }
    },
    //获取语言
    async getLang() {
      const { data: res } = await this.$axios({
        method: 'POST',
        url: this.$store.getters.path.langList,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
        },
      })

      if (res.code != 0) {
        return this.$message.error(res.msg)
      } else {
        this.langList = res.data
      }
    },
    // 提交
    submit() {
      if (this.type === 0) {
        this.add()
      } else {
        this.update()
      }
    },
    // 取消
    reset() {
      this.form = {
        tabType: null,
        tabName: null,
        tabCode: null,
        tabOrder: null,
        valid: 0,
      }
      this.isDialog = false
    },
    change(info) {
      this.form = {
        id: info.id,
        tabType: info.tabType,
        tabName: info.tabName,
        tabCode: info.tabCode,
        tabOrder: info.tabOrder,
        valid: info.valid,
      }
      this.type = 1
      this.isDialog = true
    },
    // 格式化时间
    formatDate(row, column) {
      // 获取单元格数据
      let data = row[column.property] * 1000
      if (data == null) {
        return null
      }
      let dt = new Date(data)
      return (
        dt.getFullYear() +
        '-' +
        (dt.getMonth() + 1) +
        '-' +
        dt.getDate() +
        ' ' +
        dt.getHours() +
        ':' +
        dt.getMinutes() +
        ':' +
        dt.getSeconds()
      )
    },
  },
}
</script>

<style scoped lang="scss">
.room_tab {
  &__title {
    font-size: 28px;
    font-weight: 700;
    margin-bottom: 20px;
  }

  &__search {
    span {
      font-size: 20px;
      font-weight: 600;
      margin-right: 15px;
      margin-left: 15px;
    }

    .searchBtn {
      margin-left: 10px;
    }
  }
}
</style>
